function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("ellipse", {
  cx: 29.692,
  cy: 29.802,
  fill: "#FA6358",
  fillOpacity: 0.15,
  rx: 28.774,
  ry: 29.403
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#444",
  d: "M63.016 31.888h-3.388v-5.632c0-1.144-.968-2.112-2.112-2.112H36.528c-1.144 0-2.112.968-2.112 2.112v5.632h-3.432c-1.144 0-2.112.968-2.112 2.112v13.728c0 1.144.968 2.112 2.112 2.112h3.432v13.948c0 1.144.968 2.112 2.112 2.112h20.944c1.1 0 2.024-.836 2.156-1.98V49.796h3.344c1.144 0 2.112-.968 2.112-2.112V34c.044-1.144-.924-2.112-2.068-2.112zm-26.18-5.368h20.372v5.324H36.836V26.52zm20.372 36.96H36.836V49.84h20.372v13.64zm5.5-16.06H31.292V34.308h31.416V47.42z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#444",
  d: "M43.04 54.68h7.92a1.23 1.23 0 001.232-1.232c0-.704-.528-1.232-1.232-1.232h-7.92a1.23 1.23 0 00-1.232 1.232 1.23 1.23 0 001.232 1.232zm0 5.984h7.92a1.23 1.23 0 001.232-1.232c0-.704-.528-1.232-1.232-1.232h-7.92a1.23 1.23 0 00-1.232 1.232 1.23 1.23 0 001.232 1.232zm16.104-20.68a1.672 1.672 0 100-3.344 1.672 1.672 0 000 3.344z"
});

function SvgPrintinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 69 67"
  }, props), _ref, _ref2, _ref3);
}

export default SvgPrintinline;